import type { Action } from "svelte/action";
import { on } from "svelte/events";

const passive = { passive: true };
const once = { once: true };

/**
 *
 *
 *
 *
 *
 */
export const longPressEvent = ((node: HTMLElement, threshold = 500) => ({
  /*                                                                                */
  destroy: on(
    node,
    "touchstart",
    () => {
      /*                                                */
      const timeout = setTimeout(() => node.dispatchEvent(new CustomEvent("longpress")), threshold);

      /*                                                                                       */
      const cancel = (): void => clearTimeout(timeout);

      on(node, "touchend", cancel, { ...once, ...passive });
      on(node, "touchcancel", cancel, { ...once, ...passive });
    },
    passive,
  ),
})) satisfies Action<HTMLElement, number | undefined>;
